export default __webpack_public_path__ + "static/rooms-with-views-hero-image-d681336df02e7b3741dbdac988b2a0bc.jpg";